import { useEffect } from "react";
import history from "../../history";
import { useAuth } from "./useAuth";

/**
 * Hook to redirect VRP users to the home page if they haven't selected a client profile yet.
 */
export function useVrpRedirect() {
  const [auth] = useAuth();
  const user = auth.user;

  useEffect(() => {
    if (user?.role === "VRP" && !user?.client_profile) {
      history.push("/");
    }
  }, [user]);
}

export function useNotVrpRedirect() {
  const [auth] = useAuth();
  const user = auth.user;

  useEffect(() => {
    if (user?.role !== "VRP" || user?.client_profile) {
      history.push("/");
    }
  }, [user]);
}
